class LayoutCustomizer {
    constructor() {
        this.defaultConfig = {
            theme: "light",
            direction: "ltr",
            fontFamily: "default",
            sidebarTheme: "light",
            fullscreen: false,
        }
        const configCache = localStorage.getItem("__TRIVEO_CONFIG_v1__")
        if (configCache) {
            this.config = JSON.parse(configCache)
        } else {
            this.config = { ...this.defaultConfig }
        }
        this.html = document.documentElement
        this.sidebar = document.getElementById("layout-sidebar")

        window.config = this.config
    }

    updateTheme = () => {
        localStorage.setItem("__TRIVEO_CONFIG_v1__", JSON.stringify(this.config))

        // O produto tem um tema só; `data-theme` deixou de variar. Mantido
        // fixo em "light" porque o daisyUI e os overrides de tenant
        // (:root[data-theme="light"]) casam por esse seletor.
        this.html.setAttribute("data-theme", "light")

        // O trilho NÃO recebe mais `data-theme` próprio. A aparência dele vem
        // dos tokens `--sidebar-*`, resolvidos contra o fundo que o tenant
        // escolhe. Setar um tema aqui reintroduziria o acoplamento que os
        // escopos de superfície existem para eliminar.
        this.sidebar?.removeAttribute("data-theme")

        this.html.dir = this.config.direction

        if (this.config.fullscreen) {
            this.html.setAttribute("data-fullscreen", "")
        } else {
            this.html.removeAttribute("data-fullscreen")
        }

        if (this.config.fontFamily !== "default") {
            this.html.setAttribute("data-font-family", config.fontFamily)
        } else {
            this.html.removeAttribute("data-font-family")
        }
    }

    initEventListener = () => {
        // Sem controles de tema: o produto tem um tema só, e a aparência do
        // trilho é definida pelo tenant em Identidade visual — não é
        // preferência de quem usa.

        const fontFamilyControls = document.querySelectorAll("[data-font-family-control]")
        fontFamilyControls.forEach((control) => {
            control.addEventListener("click", () => {
                this.config.fontFamily =
                    control.getAttribute("data-font-family-control") ?? "default"
                this.updateTheme()
            })
        })

        const dirControls = document.querySelectorAll("[data-dir-control]")
        dirControls.forEach((control) => {
            control.addEventListener("click", () => {
                this.config.direction = control.getAttribute("data-dir-control") ?? "ltr"
                this.updateTheme()
            })
        })

        const fullscreenControls = document.querySelectorAll("[data-fullscreen-control]")
        fullscreenControls.forEach((control) => {
            control.addEventListener("click", () => {
                if (document.fullscreenElement != null) {
                    this.config.fullscreen = false
                    document.exitFullscreen()
                } else {
                    this.config.fullscreen = true
                    this.html.requestFullscreen()
                }
                this.updateTheme()
            })
        })

        const resetControls = document.querySelectorAll("[data-reset-control]")
        resetControls.forEach((control) => {
            control.addEventListener("click", () => {
                this.config = { ...this.defaultConfig }
                if (document.fullscreenElement != null) {
                    document.exitFullscreen()
                }
                this.updateTheme()
            })
        })

        const fullscreenMedia = window.matchMedia("(display-mode: fullscreen)")
        const fullscreenListener = () => {
            this.config.fullscreen = fullscreenMedia.matches
            this.updateTheme()
        }
        fullscreenMedia.addEventListener("change", fullscreenListener)
        fullscreenListener()
    }

    initLeftmenu = () => {
        const initMenuActivation = () => {
            const menuItems = document.querySelectorAll(".sidebar-menu-activation  a")
            let currentURL = window.location.href
            const fallbackURL = currentURL + "dashboards-ecommerce"
            if (window.location.pathname === "/") {
                currentURL += "dashboards-ecommerce.html"
            }
            menuItems.forEach((item) => {
                if (item.href === currentURL || item.href === fallbackURL) {
                    item.classList.add("active")
                    const parentElement1 = item.parentElement.parentElement
                    if (parentElement1.classList.contains("collapse-content")) {
                        const inputElement1 = parentElement1.parentElement.querySelector("input")
                        if (inputElement1) {
                            inputElement1.checked = true
                        }
                    }
                }
            })
        }

        const scrollToActiveMenu = () => {
            const simplebarEl = document.querySelector("#layout-sidebar [data-simplebar]")
            const activatedItem = document.querySelector("#layout-sidebar .menu a.active")
            if (simplebarEl && activatedItem) {
                const simplebar = new SimpleBar(simplebarEl)
                const top = activatedItem?.getBoundingClientRect().top
                if (top && top !== 0) {
                    simplebar.getScrollElement().scrollTo({ top: top - 300, behavior: "smooth" })
                }
            }
        }

        initMenuActivation()
        scrollToActiveMenu()
    }

    afterInit = () => {
        this.initEventListener()
        this.initLeftmenu()
    }

    init = () => {
        this.updateTheme()
        window.addEventListener("DOMContentLoaded", this.afterInit)
    }
}

new LayoutCustomizer().init()
